"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrainTypeFilterOption = void 0;
const mobx_1 = require("mobx");
class StrainTypeFilterOption {
    constructor() {
        this.selectedStrainTypes = mobx_1.observable.map();
        this.reset = () => {
            this.selectedStrainTypes.clear();
        };
        this.setSelectedStrainTypes = (selectedStrainTypes) => {
            this.selectedStrainTypes.clear();
            selectedStrainTypes.forEach((strainType) => {
                this.selectedStrainTypes.set(strainType, null);
            });
        };
    }
    get isSet() {
        return this.selectedStrainTypes.size > 0;
    }
}
exports.StrainTypeFilterOption = StrainTypeFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], StrainTypeFilterOption.prototype, "selectedStrainTypes", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], StrainTypeFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], StrainTypeFilterOption.prototype, "setSelectedStrainTypes", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], StrainTypeFilterOption.prototype, "isSet", null);
//# sourceMappingURL=StrainTypeFilterOption.js.map